<template>
  <div>
    <dialog-popup
      :dialog="value"
      @dialogItem="renameDepartment($event)"
      @back="$emit('onClose')"
      @clearApiError="$emit('clearError')"
      :label="'Department'"
      ghostText="Rename"
      :type="type"
      :buttonLabel="$loader.isAppLoading ? 'Save' : 'Save'"
      :breakDescription="false"
      :allowSpecialCharacters="true"
      :isShowCharCounter="true"
      :maxWidth="'665'"
      :orgObjectType="'department'"
      :apiError="errorMessage || nameValidation.error.value"
      :checking="nameValidation.checking.value"
      @name-change="onNameChange"
      :duplicateNotAllowed="true"
      :initialValue="name"
      placeholder="Rename Department"
      :max_char="50"
    />
  </div>
</template>

<script setup>
import DialogPopup from "@components/Modal/DialogPopup.vue";
import { useOrgObjectNameValidation } from "@/composables/useOrgObjectNameValidation";

const props = defineProps({
  type: {
    type: String,
    required: false,
  },
  value: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
  departmentId: {
    type: [String, Number],
    default: null,
  },
});

const emit = defineEmits(["update:modelValue", "input", "onSave", "onClose", "clearError"]);

const nameValidation = useOrgObjectNameValidation({
  type: "department",
  excludeId: () => props.departmentId,
});

const onNameChange = (value) => {
  nameValidation.name.value = (value || "").trim() === (props.name || "").trim() ? "" : value || "";
};

const renameDepartment = (departmentName) => {
  emit("onSave", departmentName);
};
</script>
